<span class="cmdk-row__icon" aria-hidden="true">
  @if (item().command.id === 'nav:flow') {
    <im-flow-mark variant="ink" [size]="18" />
  } @else {
    <paper-icon [name]="icon()" [size]="18" />
  }
</span>

<span class="cmdk-row__text">
  <span class="cmdk-row__title">{{ item().title }}</span>
  @if (item().subtitle) {
    <span class="cmdk-row__subtitle">{{ item().subtitle }}</span>
  }
</span>

@if (quickOpenKey(); as digit) {
  <paper-kbd class="cmdk-row__quick" [keys]="digit" [mod]="true" size="sm" />
} @else if (shortcutKeys(); as keys) {
  <paper-kbd class="cmdk-row__shortcut" [keys]="keys" [mod]="usesModifier()" size="sm" />
}
